<template>
  <div>
    <b-row style="margin-top: 2em">
      <b-col>
        <h4 class="text-secondary">{{ $t("globals.service_devices") }}:</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="my-3">
        <b-input-group>
          <b-form-input
            v-model="filter"
            :placeholder="$t('globals.type_to_search')"
          />
          <b-input-group-append>
            <b-btn
              variant="warning"
              :disabled="!filter"
              @click="filter = ''"
            >
              {{ $t("globals.clear") }}
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="2" class="my-3">
        <b-form-select v-model="perPage" :options="perPageOptions" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          class="mt-3"
          bordered
          hover
          small
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items="service.service_devices"
          :fields="fields"
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          @row-clicked="rowClicked"
          @filtered="currentPage = 1"
        >
          <template v-slot:cell(action)="row">
            <b-btn
              v-if="service.status == 'created' && (
                row.item.service_device_type == 'replacement_install'
                || row.item.service_device_type == 'replacement_unistall'
                || row.item.service_device_type == 'inspection'
                )"
              class="float-right"
              size="sm"
              pill
              variant="light"
              @click="openEditServiceDeviceModal(row.item)"
            >
              <v-icon name="wrench"></v-icon>
            </b-btn>

            <a v-if="fieldtrackerService && fieldtrackerService.tasks && row.item.fieldtracker_reference"
                target="_blank" :href="fieldTrackerBaseUrl+'/tasks/search?q[uuid_eq]='+row.item.fieldtracker_reference">
              <b-btn
                class="float-right"
                size="sm"
                pill
                variant="light"
              >
                <v-icon name="search"></v-icon>
              </b-btn>
            </a>
          </template>
          <template v-slot:cell(imei)="row">
            <router-link
              style="color:#17a2b8"
              :to="{name: 'device', params:{ id: row.item.device_id }}"
            >
              {{ row.item.imei }}
            </router-link>
          </template>
          <template v-slot:cell(license_plate)="row">
            <span v-if="fieldtrackerService && fieldtrackerService.tasks && row.item.fieldtracker_reference">
              {{ getPlate(fieldtrackerService.tasks.find(task => task.uuid == row.item.fieldtracker_reference)) }}
            </span>
            <span v-else>{{row.item.license_plate}}</span>
          </template>
          <template v-slot:cell(status)="row">
            <span v-if="fieldtrackerService && fieldtrackerService.tasks && row.item.fieldtracker_reference">
              {{ fieldtrackerService.tasks.find(task => task.uuid == row.item.fieldtracker_reference).status }}
            </span>
            <span v-else>{{row.item.status}}</span>
          </template>
          <template v-slot:cell(installation_id)="row">
            <b-btn
              v-if="row.item.installation_id"
              variant="info"
              size="sm"
              class="float-right mx-1"
              @click="goToInstallationForm(row.item.installation_id)"
            >
              {{ row.item.installation_id }}
            </b-btn>
          </template>
          <template v-slot:row-details="row">
            <b-card border-variant="info">
              <b-row>
                <b-col>
                  <b-table small :items="row.item.audits">
                    <template v-slot:cell(created_at)="row">
                      <div v-b-tooltip.hover :title="row.item.created_at">
                        {{ row.item.created_at.substring(0, 10) }}
                      </div>
                    </template>
                    <template v-slot:cell(agent)="row">
                      {{ row.item.agent.full_name }}
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="service.service_devices.length"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
    </b-row>
    <ulu-service-device-edit-modal
      :show="editServiceDeviceModal.show"
      :close="closeModals"
      :service_device="editServiceDeviceModal.device"
      :service="service"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    "ulu-service-device-edit-modal": () =>
      import(
        "@/components/services/service/ServiceDeviceEditModal.vue"
      ),
  },
  props: {
    refresh: Function,
    service: Object,
    fieldtrackerService: {
      type: Object,
      default: () => {
        return null;
      },
    }
  },
  data() {
    return {
      sortBy: "created_at",
      sortDesc: true,
      filter: null,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [
        { text: "10 " + this.$t("globals.per_page"), value: 10 },
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "30 " + this.$t("globals.per_page"), value: 30 }
      ],
      editServiceDeviceModal: {
        show: false,
        device: {
          id: null,
          device_id: null,
          imei: "",
          license_plate: null
        }
      },
      fields: [
        "id",
        "imei",
        {
          key: "license_plate",
          label: this.$t("globals.license_plate")
        },
        {
          key: "status",
          label: this.$t("globals.status")
        },
        {
          key: "service_device_type",
          label: this.$t("globals.device_action")
        },
        {
          key: "installation_id",
          label: this.$t("globals.installation_form")
        },
        {
          key: "action",
          label: this.$t("globals.action")
        }
      ]
    };
  },
  methods: {
    getPlate(task) {
      let plates = []

      if(task) {
        Object.keys(task.parameters_json).forEach(key => {
          if (key.includes('license_plate') || key.includes('kenteken')) {
            if(task.parameters_json[key]) {
              plates.push(key+": "+task.parameters_json[key])
            }
          }
        })
      }
      return plates.join(', ')
    },
    openEditServiceDeviceModal(device) {
      this.editServiceDeviceModal.device = device;
      this.editServiceDeviceModal.show = true;
    },
    closeModals() {
      this.editServiceDeviceModal.show = false;
      this.refresh();
    },
    rowClicked(item) {
      item._showDetails = !item._showDetails;
      this.service.service_devices.forEach(e => {
        if (item.id != e.id) {
          e._showDetails = false;
        }
      });
    },
    goToInstallationForm(id) {
      window.open(
        `${this.getWebAppUrl}/admin/device_installations/${id}`,
        "_blank"
      );
    },
  },
  computed: {
    ...mapGetters(["getWebAppUrl", "getFieldTrackerUrl"]),
    fieldTrackerBaseUrl() {
      let path = new URL(this.getFieldTrackerUrl).pathname
      return this.getFieldTrackerUrl.replace(path, "");
    },
  }
};
</script>
